import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';
import { BankAccount } from '../../views/banking/models/bank-account';
import { AnnuityPensionAccountPaymentInstructionStatusEnum } from './enum/annuity-pension-account-payment-instruction-status.enum';
import { PaymentMethodType } from '../types/dto/payment-method-type';
import { PaymentMethodTypeEnum } from '../enum/shared/payment-method-type-enum';
import { AnnuityPensionAccountPaymentInstructionAvailableActions } from './annuity-pension-account-payment-instruction-available-actions';
import { AnnuityDispositionDisplayEnum } from './enum/annuity-disposition-display.enum';
import { AnnuityBenefitSchedulePhase } from './annuity-benefit-schedule-phase';
import { LifeStatusTypeIdEnum } from '../life-status/enum/life-status-type-id.enum';
import { AnnuityPayeeDesignationEnum } from './enum/annuity-payee-designation.enum';
import { AnnuitySplitReasonEnum } from './enum/annuity-split-reason.enum';
import { AnnuityDispositionEnum } from './enum/annuity-disposition.enum';

export class AnnuityPensionAccountPaymentInstruction implements Deserializable {
  public id!: string;
  public startDate!: string;
  public endDate!: string | null;
  public payeeId!: number | null;
  public payeeFirstName!: string | null;
  public payeeLastName!: string | null;
  public payeeFullName!: string;
  public payeeLifeStatusId!: LifeStatusTypeIdEnum | null;
  public payeeDesignationId!: AnnuityPayeeDesignationEnum;
  public payeeDesignation!: BaseType;
  public dispositionId!: AnnuityDispositionEnum | null;
  public disposition!: BaseType | null;
  public dispositionDisplay!: AnnuityDispositionDisplayEnum | null;
  public statusId!: AnnuityPensionAccountPaymentInstructionStatusEnum;
  public status!: BaseType;
  public splitReasonId!: AnnuitySplitReasonEnum | null;
  public splitReason!: BaseType | null;
  public isParent!: boolean;
  public allocationPercentage!: number;
  public paymentAmount!: number;
  public commutedValue!: number | null;
  public retainJointLifeSurvivorship!: boolean;
  public benefitSchedule!: AnnuityBenefitSchedulePhase[];
  public paymentMethodId!: PaymentMethodTypeEnum;
  public paymentMethod!: PaymentMethodType;
  public bankAccount!: BankAccount | null;
  public bankAccountId!: number | null;
  public nextPaymentDate!: string | null; // TODO: Confirm the need for this property, SPP-2999
  public availableActions!: AnnuityPensionAccountPaymentInstructionAvailableActions | null;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;
    this.payeeFullName = `${this.payeeFirstName ?? ''} ${this.payeeLastName ?? ''}`.trim();
    if (this.status) this.status = Deserialize.instanceOf(BaseType, this.status);
    if (this.payeeDesignation) this.payeeDesignation = Deserialize.instanceOf(BaseType, this.payeeDesignation);
    if (this.disposition) this.disposition = Deserialize.instanceOf(BaseType, this.disposition);
    if (this.splitReason) this.splitReason = Deserialize.instanceOf(BaseType, this.splitReason);
    if (this.paymentMethod) this.paymentMethod = Deserialize.instanceOf(PaymentMethodType, this.paymentMethod);
    if (this.bankAccount) this.bankAccount = Deserialize.instanceOf(BankAccount, this.bankAccount);
    this.availableActions = this.availableActions
      ? Deserialize.instanceOf(AnnuityPensionAccountPaymentInstructionAvailableActions, this.availableActions)
      : null;
  }
}
